var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.83,
    height: 71,
    viewBox: "0 0 74.83 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 74.83,
    height: 71,
    fill: "none",
    stroke: "#0182f0",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M27.433,32.962a9.439,9.439,0,1,0,9.438-9.438A9.438,9.438,0,0,0,27.433,32.962Z",
    transform: "translate(0.971 0.833)",
    fill: "#faf7a3",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M39.8,29.709a3.147,3.147,0,0,0-6.293,0c0,1.737,1.574,2.36,3.147,3.147S39.8,34.263,39.8,36a3.147,3.147,0,0,1-6.293,0",
    transform: "translate(1.185 0.94)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    y1: 1.259,
    transform: "translate(37.843 26.243)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    y2: 1.258,
    transform: "translate(37.843 40.087)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M42.578,2.295a8.455,8.455,0,0,0-5.034-1.258A8.453,8.453,0,0,0,32.51,2.295L26.217,1.037l5.034,10.068H43.836L48.87,1.037Z",
    transform: "translate(0.927 0.037)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M14.828,44.515c-.04-.2-.084-.4-.13-.614a23.107,23.107,0,0,1-.555-4C13.971,30.9,21.679,19,31.993,15.623H43.95C54.264,19,61.972,30.9,61.8,39.9a23.18,23.18,0,0,1-.556,4c-.642,2.868-.7,4.9.241,10.345",
    transform: "translate(0.5 0.553)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M42.449,15.794H32.381a2.517,2.517,0,0,1,0-5.034H42.449a2.517,2.517,0,1,1,0,5.034Z",
    transform: "translate(1.057 0.381)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M22.816,56.842A2.077,2.077,0,0,1,24.9,54.771",
    transform: "translate(0.807 1.938)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M4.712,59l23.449,8.329a18.121,18.121,0,0,0,11.488.212L73.44,56.925a10.175,10.175,0,0,0-11.358-4.068L48.448,56.925l-8.332-2.072",
    transform: "translate(0.167 1.855)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M.592,49.509a18.622,18.622,0,0,1,8.263-5.478c4.132-1.37,17.587.123,23.041,2.836l.036.018h10.19a4.316,4.316,0,0,1,4.332,3.447,4.153,4.153,0,0,1-4.109,4.838H25.684",
    transform: "translate(0.021 1.54)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueIcon);
export default __webpack_public_path__ + "static/media/revenue-icon.3ab423406623cfa9103f834978025e0f.svg";
export { ForwardRef as ReactComponent };